import { DashboardKeyMetricsService } from '@services/dashboard-key-metrics.service';
import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FarmOverviewComponent } from '../farm-overview/farm-overview.component';
import { LiveAlertsComponent } from '../live-alerts/live-alerts.component';
import { UpcomingTasksComponent } from '../upcoming-tasks/upcoming-tasks.component';
@Component({
    selector: 'app-dashboard-insight-panel',
    standalone: true,
    imports: [
        CommonModule,
        FarmOverviewComponent,
        LiveAlertsComponent,
        UpcomingTasksComponent
    ],
    templateUrl: './dashboard-insight-panel.component.html',
    styleUrl: './dashboard-insight-panel.component.scss'
})
export class DashboardInsightPanelComponent implements OnInit, OnChanges {
    @Input() farmId?: number | null;
    activeTab: string = 'farm-overview';
    userDetail: any;
    

    farms: Array<{
        farm: any;
        alerts: { critical: number; warning: number; info: number };
        houses: any[];
    }> = [];
    loading = false;
    error?: string;

    constructor(private dashboardService: DashboardKeyMetricsService) { }

    ngOnInit(): void {
        const userDetailString = localStorage.getItem('UserDetail');
        this.userDetail = userDetailString
            ? JSON.parse(userDetailString)
            : null;
        
        // Initial load is now handled entirely by ngOnChanges when farmId is set
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['farmId'] && changes['farmId'].currentValue) {
            const currentFarmId = changes['farmId'].currentValue;
            if (currentFarmId) {
                const userId = this.userDetail?.id;
                if (userId) {
                    this.loadFarmOverview(userId, currentFarmId);
                }
            }
        }
    }

    private loadFarmOverview(userId: number, farmId: number) {
        this.loading = true;
        this.error = undefined;
        this.dashboardService.getDashboardFarmOverview(userId, farmId).subscribe({
            next: (resp: any) => {
                const farmsResp = resp?.farms || [];
                if (!farmsResp.length) {
                    this.error = 'No farms found';
                    this.loading = false;
                    return;
                }
                this.farms = farmsResp.map((f: any) => {
                    const farm = {
                        name: f.farmName,
                        address: f.address || '—',
                        chicks: f.numberOfChicks,
                        mortalityPct: f.mortalityPercentage,
                        feedConsumption: f.feedConsumption,
                        feedRemaining: f.feedRemaining,
                        avgWeight: f.averageWeight,
                        outdoorHumidity: f.outdoorHumidity,
                        outdoorTemperature: f.outdoorTemperature,
                        waterConsumption: f.waterConsumption,
                        waterRemaining: f.waterRemaining,
                        dieselRemaining: f.dieselRemaining,
                        dieselConsumptionCycle: f.dieselConsumptionCycle
                    };
                    const alerts = {
                        critical: f.activeAlerts?.criticalCount || 0,
                        warning: f.activeAlerts?.warningCount || 0,
                        info: f.activeAlerts?.infoCount || 0
                    };
                    const houses = (f.houses || []).map((h: any) => ({
                        houseId: h.houseId,
                        name: h.houseName,
                        chicks: h.numberOfChicks,
                        temperatureC: h.temperature,
                        humidity: h.humidity,
                        co2: h.co2,
                        partitions: h.partitions?.length || 0,
                        alerts: {
                            critical: h.activeAlerts?.criticalCount || 0,
                            warning: h.activeAlerts?.warningCount || 0,
                            info: h.activeAlerts?.infoCount || 0
                        },
                        dailyWaterConsumption: h.dailyWaterConsumption,
                        cycleWaterConsumption: h.cycleWaterConsumption,
                        feedConsumption: h.feedConsumption,
                        feedRemaining: h.feedRemaining,
                        partitionsList: (h.partitions || []).map((p: any) => ({
                            id: p.partitionId,
                            name: p.partitionName,
                            chicks: 0,
                            tempC: 0,
                            waterUsageLDay: 0
                        }))
                    }));
                    return { farm, alerts, houses };
                });
                this.loading = false;
            },
            error: () => {
                this.error = 'Failed to load farm overview';
                this.loading = false;
            }
        });
    }
    tabs = [
        { id: 'farm-overview', label: 'Farm Overview' }
        // {id: 'feed-inventory', label: 'Feed & Inventory'},
        // {id: 'analytics', label: 'Analytics'}
    ];

    setActiveTab(tabId: string): void {
        this.activeTab = tabId;
    }

    isActiveTab(tabId: string): boolean {
        return this.activeTab === tabId;
    }
}
